import type { ActionExecutor } from "../TriggerEngine.interfaces";

export const micMute: ActionExecutor = (radio, config, { emitAction }) => {
  const targetId = config?.deviceId;

  if (targetId && targetId !== "__all__") {
    radio.Microphones.stop(targetId);

    emitAction("mic_state_changed", { deviceId: targetId, active: false });
  } else {
    const activeMics = radio.Microphones.getActiveMicrophones();

    for (const deviceId of activeMics) {
      radio.Microphones.stop(deviceId);

      emitAction("mic_state_changed", { deviceId, active: false });
    }
  }
};

export const micUnmute: ActionExecutor = (radio, config, { emitAction }) => {
  const targetId = config?.deviceId;

  if (targetId && targetId !== "__all__") {
    const mic = radio.Microphones.get(targetId);

    if (mic) {
      radio.Microphones.play(mic.deviceInfo.deviceId, mic.capabilities);

      emitAction("mic_state_changed", {
        deviceId: mic.deviceInfo.deviceId,
        active: true,
      });
    }
  } else {
    const allMics = radio.Microphones.getAll();

    const activeMics = new Set(radio.Microphones.getActiveMicrophones());

    for (const mic of allMics) {
      if (!activeMics.has(mic.deviceInfo.deviceId)) {
        radio.Microphones.play(mic.deviceInfo.deviceId, mic.capabilities);

        emitAction("mic_state_changed", {
          deviceId: mic.deviceInfo.deviceId,
          active: true,
        });
      }
    }
  }
};
